import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import styles from "./index.css";

const CategoryTile = ({
  products,
  categoryUrl,
  itemCount,
  formatTranslation,
  formatNumber,
}) => {
  const imageUrls = products.map(({ image }) => image);

  const itemCountToDisplay = itemCount < 500 ? itemCount : 500;

  return (
    <a className={styles.categoryTile} href={categoryUrl}>
      <div className={styles.hero}>
        {imageUrls.map((imageUrl, index) => (
          <img key={index} src={`//${imageUrl}`} alt="" />
        ))}
      </div>
      <div className={styles.footer}>
        <p className={styles.itemCount}>
          {formatTranslation("plp_web_item_count", {
            smart_count: itemCountToDisplay,
            count:
              itemCountToDisplay < 500
                ? formatNumber(itemCountToDisplay)
                : `${formatNumber(itemCountToDisplay)}+`,
          })}
        </p>
        <div className={styles.viewAll}>
          {formatTranslation("plp_curatedcategories_carousel_cta_view_all")}
        </div>
      </div>
    </a>
  );
};

CategoryTile.propTypes = {
  categoryUrl: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  itemCount: PropTypes.number.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired,
};

export default withTranslation(CategoryTile);
